<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.6004 11.9999C21.6004 17.3018 17.3023 21.5999 12.0004 21.5999C6.69846 21.5999 2.40039 17.3018 2.40039 11.9999C2.40039 6.69797 6.69846 2.3999 12.0004 2.3999C17.3023 2.3999 21.6004 6.69797 21.6004 11.9999ZM13.2004 7.1999C13.2004 7.86264 12.6631 8.3999 12.0004 8.3999C11.3377 8.3999 10.8004 7.86264 10.8004 7.1999C10.8004 6.53716 11.3377 5.9999 12.0004 5.9999C12.6631 5.9999 13.2004 6.53716 13.2004 7.1999ZM10.8004 10.7999C10.1377 10.7999 9.6004 11.3372 9.6004 11.9999C9.6004 12.6626 10.1377 13.1999 10.8004 13.1999V16.7999C10.8004 17.4626 11.3377 17.9999 12.0004 17.9999H13.2004C13.8631 17.9999 14.4004 17.4626 14.4004 16.7999C14.4004 16.1372 13.8631 15.5999 13.2004 15.5999V11.9999C13.2004 11.3372 12.6631 10.7999 12.0004 10.7999H10.8004Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 24,
    color: "currentColor",
  },
);
</script>
